import { inject, Injectable } from "@angular/core";
import { PopupService } from "@kernel/popups/popup/modules/confirmation-dialog/services/confirmation-popup/popup.service";
import { filter, from, switchMap } from "rxjs";
import { getStatusConfirmationPopupOptions } from "../../../../../shared-core/config/confirmation-popup.config";
import { StockTypeApiService } from "./stock-type-api.service";

/**
 * Handles UI-level logic and coordination for stock type operations,
 * acting as a bridge between the presentation layer and the stock type API service.
 */
@Injectable({ providedIn: "root" })
export class StockTypeService {
  private stockTypeApiService = inject(StockTypeApiService);
  private popupService = inject(PopupService);

  /**
   * Toggles the enabled status of a StockType row.
   * Displays a confirmation popup before calling the appropriate API
   * (enable or disable), then updates the row state based on the response.
   *
   * @param row - The table/listing row representing a StockType.
   * @returns An observable that emits when the status change completes.
   */
  switchRowStatus(id: string, enabled: boolean) {
    const apiChangeStatus = !enabled
      ? this.stockTypeApiService.enableStockType.bind(this.stockTypeApiService)
      : this.stockTypeApiService.disableStockType.bind(this.stockTypeApiService);

    return from(this.popupService.confirm(getStatusConfirmationPopupOptions(enabled))).pipe(
      filter(confirmed => confirmed),
      switchMap(() => apiChangeStatus(id))
    );
  }
}
